import { Animation } from "@story/story_assets/animations"

document.addEventSelectorListener("ajaxbefore", "form[data-remote][data-ajax-feedback]", function(event, target) {
	for (let element of document.querySelectorAll(target.getAttribute("data-ajax-feedback"))) {
		element.classList.add("sending-request");
	}
});

document.addEventSelectorListener("ajaxcompleted", "form[data-remote][data-ajax-feedback]", function(event, target) {
	for (let element of document.querySelectorAll(target.getAttribute("data-ajax-feedback"))) {
		element.classList.remove("sending-request");
	}
});

document.addEventListener("ajaxsuccess", function(event) {
	let data = event.detail.responseJSON;
	if (data.redirect_url) {
		window.location = data.redirect_url;
	}
	else if (data.replace_url) {
		window.history.pushState({}, "", data.replace_url);
	}
});

document.addEventSelectorListener("change", "form [data-submit='change']", function(event, target) {
	if (target.getAttribute("type") == "radio" && !target.checked) {
		// Do not do anything, if radio has been unchecked.
		return;
	}

	target.classList.add("sending-request");
	// document.querySelector(".category-products, .news-articles").classList.add("sending-request");

	var form = target.closest("form");
	form.trigger("submit");
});

document.addEventSelectorListener("click", ".category-tree span.plus", function(event, target) {
	let element = target.parentNode;
	let isExpandable = element.classList.contains("has-children");
	if (!isExpandable) {
		return;
	}

	let isExpanded = (element.classList.contains("active") || element.classList.contains("expanded")) && !element.classList.contains("collapsed");
	let submenu = element.querySelector("ul");
	if (isExpanded) {
		Animation.slideUp(submenu);
		element.classList.remove("expanded");
		element.classList.add("collapsed");
	}
	else {
		Animation.slideDown(submenu);
		element.classList.remove("collapsed");
		element.classList.add("expanded");
	}
});
